import type {KeyboardEvent} from 'react';

/**
 * Keyboard behaviour of a native button (and MUI's ButtonBase) for a `role="button"` element that isn't a <button>:
 * Enter fires on keydown, Space on keyup. Keys pressed on a child (a link inside the row) are left alone.
 * `onToggle` receives the element, as a click handler would get `event.currentTarget`.
 */
export const toggleKeys = (onToggle: (target: HTMLElement) => void) => ({
    onKeyDown: (e: KeyboardEvent<HTMLElement>) => {
        if (e.target !== e.currentTarget) return;
        if (e.key === ' ') e.preventDefault();
        if (e.key === 'Enter') {
            e.preventDefault();
            onToggle(e.currentTarget);
        }
    },
    onKeyUp: (e: KeyboardEvent<HTMLElement>) => {
        if (e.target === e.currentTarget && e.key === ' ') onToggle(e.currentTarget);
    }
});
